import { Layout, Card, Row, Col, Typography, Flex, Divider } from 'antd';
import { useEffect, useRef } from 'react';
import { 
  TeamOutlined, 
  RocketOutlined, 
  NotificationOutlined, 
  CalendarOutlined, 
  CheckCircleOutlined,
  MessageOutlined 
} from '@ant-design/icons';
import { BOT_NAME } from '../constants';

const { Content, Header, Footer } = Layout;
const { Title, Paragraph, Text } = Typography;

export type TGUser = {
    id: number;
    username?: string;
    photo_url?: string;
    first_name: string;
    last_name?: string;
    auth_date: number;
    hash: string;
};

function IndexPage() {
    const _containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-widget.js?21';
        script.setAttribute('data-telegram-login', BOT_NAME);
        script.setAttribute('data-request-access', 'write');

        if (process.env.NODE_ENV === 'production') {
            script.setAttribute('data-auth-url', 'https://todo.vdelo.cloud/api/auth');
        } else {
            script.setAttribute('data-auth-url', 'http://127.0.0.1:3000/api/auth');
        }

        script.setAttribute('data-lang', 'ru');
        script.async = true;

        if (_containerRef.current) {
            _containerRef.current.innerHTML = '';
            _containerRef.current?.appendChild(script);
        }

        return () => {
            if (_containerRef.current) {
                _containerRef.current.innerHTML = '';
            }
        };
    }, []);

    return (
        <Layout className="landing">
            <Header>
                <Flex justify="space-between" align="center" style={{ height: '100%' }}>
                    <img className="landing__logo" src="/logo-head-white.svg" alt="vdeloLogo" />
                    <div ref={_containerRef} style={{ display: 'flex', alignItems: 'center' }} />
                </Flex>
            </Header>

            <Content className="landing__content">
                <Flex
                    className="landing__first-screen"
                    justify="center"
                    align="stretch"
                >
                    <Flex style={{ maxWidth: '650px' }} vertical justify="center">
                        <Title level={1} style={{ fontSize: '48px', fontWeight: 'bold' }}>
                            Управляйте задачами легко со ВДело!
                        </Title>
                        <Paragraph style={{ fontSize: '20px', marginBottom: '32px' }}>
                            ВДело.Трекер — ваш идеальный помощник для организации задач, повышения продуктивности и управления проектами. Простой, удобный и мощный инструмент для личной и командной работы.
                        </Paragraph>
                    </Flex>
                    <video
                        className="landing__video"
                        loop
                        muted
                        autoPlay
                        playsInline
                        poster="/images/b-preview.webp"
                        src="/b-800.mp4"
                        style={{ minHeight: '100%' }}
                    />
                </Flex>

                <Divider className="landing__divider" />

                <Flex
                    className="landing__reasons"
                    justify="center"
                >
                    <div style={{ maxWidth: '1200px', width: '100%' }}>
                        <Title level={2} style={{ textAlign: 'center', marginBottom: '48px' }}>
                            Почему выбирают ВДело?
                        </Title>
                        <Row gutter={[24, 24]}>
                            <Col xs={24} md={8}>
                                <Card 
                                    style={{ textAlign: 'center' }}
                                    cover={<TeamOutlined style={{ fontSize: '48px', marginTop: '24px' }} />}
                                >
                                    <Card.Meta 
                                        title="Командная работа" 
                                        description="Делитесь задачами, назначайте ответственных и следите за прогрессом в реальном времени."
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} md={8}>
                                <Card 
                                    style={{ textAlign: 'center' }}
                                    cover={<RocketOutlined style={{ fontSize: '48px', marginTop: '24px' }} />}
                                >
                                    <Card.Meta 
                                        title="Интуитивный интерфейс" 
                                        description="Простое и понятное управление задачами экономит ваше время и силы."
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} md={8}>
                                <Card 
                                    style={{ textAlign: 'center' }}
                                    cover={<NotificationOutlined style={{ fontSize: '48px', marginTop: '24px' }} />}
                                >
                                    <Card.Meta 
                                        title="Интеграция с Telegram" 
                                        description="Войдите через Telegram и получайте уведомления о задачах прямо в мессенджере."
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} md={8}>
                                <Card 
                                    style={{ textAlign: 'center' }}
                                    cover={<CalendarOutlined style={{ fontSize: '48px', marginTop: '24px' }} />}
                                >
                                    <Card.Meta 
                                        title="Гибкое планирование" 
                                        description="Создавайте проекты, устанавливайте дедлайны и отслеживайте прогресс."
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} md={8}>
                                <Card 
                                    style={{ textAlign: 'center' }}
                                    cover={<CheckCircleOutlined style={{ fontSize: '48px', marginTop: '24px' }} />}
                                >
                                    <Card.Meta 
                                        title="Доска задач" 
                                        description="Визуализируйте задачи с помощью удобной Kanban-доски."
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} md={8}>
                                <Card 
                                    style={{ textAlign: 'center' }}
                                    cover={<MessageOutlined style={{ fontSize: '48px', marginTop: '24px' }} />}
                                >
                                    <Card.Meta 
                                        title="MQTT-интеграция" 
                                        description="Автоматизируйте процессы с помощью MQTT для мгновенных обновлений."
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Flex>
            </Content>

            <Footer style={{ textAlign: 'center' }}>
                ВДЕЛО ДЕВ ©{new Date().getFullYear()}
            </Footer>
        </Layout>
    );
}

export default IndexPage;
